import processUserData from '@api/processors/user';

const processEducatorData = (data) => {
  if (data.processed) return data;

  return {
    ...processUserData(data),
    leaderboardMetaInfo: {
      rank: data?.leaderboardMetaInfo?.rank || null,
      value_props: (data?.leaderboardMetaInfo?.valueProps || []).map(
        (eachValue) => ({
          display_string: eachValue.displayString,
          value: eachValue.value,
          type: eachValue.type
        })
      )
    }
  };
};

export default processEducatorData;
